import Vue from 'vue'

const USER_DATA = 'user'

var user = {
  logged: false,
  // User data:
  careerId: '',
  email: '',
  accessToken: '',
  nmCareer: '',
  chargeEmail: '',
  chargeName: '',
  chargePhone: '',
  questionnaireFirst: false,
  questionnaireOneMonth: false,

  login(data) {
    if (data['careerId'] && data['email']) {
      this.logged = true
      this.setData(data)
      this.saveData()
      return true
    }
    return false
  },
  setData(data) {
    this.careerId = data['careerId']
    this.email = data['email']
    this.accessToken = data['accessToken']
    this.nmCareer = data['nmCareer']
    this.chargeEmail = data['chargeEmail']
    this.chargeName = data['chargeName']
    this.chargePhone = data['chargePhone']
    this.questionnaireFirst = data['questionnaireFirst']
    this.questionnaireOneMonth = data['questionnaireOneMonth']
    this.justLoggedIn = data['justLoggedIn'] !== undefined ? !!data['justLoggedIn'] : true
  },
  saveData() {
    var data = {
      careerId: this.careerId,
      email: this.email,
      accessToken: this.accessToken,
      nmCareer: this.nmCareer,
      chargeEmail: this.chargeEmail,
      chargeName: this.chargeName,
      chargePhone: this.chargePhone,
      questionnaireFirst: this.questionnaireFirst,
      questionnaireOneMonth: this.questionnaireOneMonth,
      justLoggedIn: this.justLoggedIn
    }
    localStorage.setItem(USER_DATA, JSON.stringify(data))
  },

  logout() {
    this.logged = false
    localStorage.removeItem(USER_DATA)
  },

  getAccessToken() {
    if (this.accessToken) {
      return this.accessToken
    } else if (localStorage.getItem(USER_DATA)) {
      var data = JSON.parse(localStorage.getItem(USER_DATA))
      if (data['accessToken']) {
        return data['accessToken']
      }
    }
    return ''
  }
}

if (localStorage.getItem(USER_DATA)) {
  var data = JSON.parse(localStorage.getItem(USER_DATA))
  user.login(data)
}

Vue.use({
  install(Vue, options) {
    Vue.prototype['$user'] = user
  }
})

export default user


// WEBPACK FOOTER //
// ./src/services/user.js